import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'request_support_form',
    initialState: {
        key: '',
        open: false,
        loading: false,
        response: null,
        error: null,
    },
    reducers: {
        openRequestSupportForm: (state) => {
            state.key = Math.random().toString();
            state.open = true;
        },
        closeRequestSupportForm: (state) => {
            state.open = false;
            state.response = null;
        },
        createRequestSupportForm: (state) => {
            state.loading = true;
        },
        setResponseSupportForm: (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        setErrorSupportForm: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
});
export const { openRequestSupportForm, closeRequestSupportForm, createRequestSupportForm, setResponseSupportForm, setErrorSupportForm, } = slice.actions;
export const requestSupportFormReducer = slice.reducer;
